<template>
  <kye-dialog :visible.sync="dialogVisible"
              v-if="dialogVisible"
              class="index-banner-iframe-dialog"
              :class="{'isDetail': isDetail}"
              :width="dialogWidth"
              @close="closeDialog"
              :canResize="false"
              style="overflow:hidden;">
    <iframe :src="url"
            v-loading="loading"
            style="height:100%;width:100%"
            autoplay=1
            allowfullscreen
            frameborder="0"></iframe>
  </kye-dialog>
</template>
<script>
import mixins from 'public/mixins'
export default {
  name: 'iframe-dialog',
  mixins: [mixins],
  data () {
    return {
      dialogVisible: false,
      token: '',
      url: '',
      loading: false,
      dialogWidth: '70%'
    }
  },
  computed: {
    isDetail () {
      return this.url.includes('/ky-style/#/detail')
    },
  },
  // created() {
  //   this.getToken()
  // },
  methods: {
    open (accessUrl) {
      if (accessUrl.includes('/ky-style/#/detail')) {
        accessUrl = accessUrl + '&width=560'
      }
      this.dialogVisible = true
      this.accessUrl = accessUrl
      this.dialogWidth = this.getDialogWidth()
      console.log(this.dialogWidth, 3333333)
      this.getToken()
    },
    getDialogWidth () {
      const queryString = this.accessUrl.split('?')[1] || this.accessUrl.split('&')[0] // 处理可能没有 ? 的情况
      const params = new URLSearchParams(queryString)
      const widthParam = params.get('width')
      console.log(widthParam, '-----------------22222222')
      if (widthParam) {
        return parseInt(widthParam) + 'px'
      }
      return '70%'
    },
    async getToken () {
      const appIds = ['WYpeAOwQrfWnqzZZnAntSw=='] // 跨声H5页面 APP_ID
      const params = {
        employeeCode: this.$store.state.user.employeeNumber,
        appIds
      }
      try {
        this.loading = true
        let res = await this.$http('fmk.monitor.login', params, { appkey: 55212 })
        this.token = res.token
        this.url = `${this.accessUrl}&appId=SP-0002&token=${this.token}`
        this.loading = false
      } catch (err) {
        this.loading = false
        console.error(err)
      }
    },
    closeDialog () {
      this.url = ''
      this.$emit('close')
    }
  }
}
</script>
<style lang="less" scoped>
.index-banner-iframe-dialog{
  &.isDetail{
    /deep/.el-dialog{
      &__header {
        background-color: #fff;
      }
    }
  }
  /deep/.el-dialog{
    height: 80vh;
    display: flex;
    flex-direction: column;
    &__header {
      background-color: var(--g-color-text);
      border-bottom: none;
    }
    &__body {
      flex: 1;
      padding: 0;
      height: 100%;
      width: 100%;
      max-height: 100%;
      display: flex;
      justify-content: center;
      background-color: var(--g-color-text);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/banner/iframe-dialog.vue